import { css, media, styled } from '@nx-kit/styling';

export const Wrapper = styled.div<{ asSelect?: boolean }>`
  position: relative;
  padding: 10px;
  user-select: none;
  z-index: ${({ theme }) => theme.global.zIndex.dropdowns};
  background-color: ${(props) => props.theme.global.color.white};

  ${({ asSelect }) =>
    asSelect &&
    css`
      width: 100%;
      border-radius: 6px;
      height: 45px;
      border: 1px solid ${(props) => props.theme.global.color.gray650};
      ${media('lg')} {
        width: auto;
      }
    `};
`;

export const ArrowStyled = styled.i<{ isOpen: boolean }>`
  pointer-events: none;
  &:after {
    content: '';
    will-change: transform;
    transition: transform 300ms ${({ theme }) => theme.global.easing.default};
    position: absolute;
    transform-origin: center;
    right: 20px;
    width: 10px;
    height: 10px;
    border-bottom: 2px solid ${({ theme }) => theme.global.color.primary};
    border-right: 2px solid ${({ theme }) => theme.global.color.primary};

    ${({ isOpen }) =>
      isOpen
        ? css`
            top: calc(50% - 2px);
            transform: rotate3d(1, 0, 0, 0) rotate3d(0, 0, 1, -135deg);
          `
        : css`
            top: calc(50% - 7px);
            transform: rotate3d(1, 0, 0, 0) rotate3d(0, 0, 1, 45deg);
          `};
  }
`;

export const CurrentStyled = styled.div<{ asSelect?: boolean }>`
  width: 100%;
  height: 25px;
  cursor: pointer;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  ${({ asSelect }) =>
    !asSelect &&
    css`
      font-weight: bold;
    `};

  ${ArrowStyled} {
    margin-left: 30px;
  }
`;
